import React from 'react'
import styles from './Card.module.css'

export const ContentCard = ({ icon, text, number, bgColor }) => {
    return (
        <div className={styles.container}>
            <div 
                className={styles.icon_container} 
                style={{ backgroundColor: bgColor }} 
            >
                { icon }
            </div>
            <div className={styles.text_container}>
                <p>{text}</p>
                <p>{number}</p>
            </div>
        </div>
    )
}